module.exports = __webpack_public_path__ + "img/RegFees-OD-contact.df11c472.svg";